import { Model } from 'core/model/Model';
import { computed } from 'mobx';
import { AssetType, getLabelTypeValue } from '@kentik/ui-shared/labels/lib';
import { ModelBase } from 'core/model/model.types';
import $assetTags from 'app/stores/assetTags/$assetTags';

export type AssetTagValueMappingJson = ModelBase & {
  asset_type: AssetType;
  asset_id: string | number;
  name?: string | null;
};

export default class AssetTagValueMappingModel extends Model<AssetTagValueMappingJson> {
  /**
   * Overrides sort values to ensure we sort by options values and by lowercase
   * so we don't get uppercase bunched at the top.
   */
  getSortValue(field: (string & keyof AssetTagValueMappingJson) | undefined): string | number {
    if (field === 'asset_type') {
      return getLabelTypeValue(this.get('asset_type'));
    }

    if (field === 'name') {
      return this.name?.toLowerCase() || '';
    }

    return super.getSortValue(field);
  }

  /**
   * Leverages an asset type's own collection to get their name.
   * Used for providing a name in the mapping table.
   */
  @computed
  get name(): string | null | undefined {
    return $assetTags.getAssetName({ assetType: this.get('asset_type'), assetId: this.get('asset_id') });
  }
}
